import { IPatient } from '../patient/states'
import { IUser } from '../user/states'

export class JobState {
  public list: JobList
  public create: object
  public update: object
  public delete: object
  public byId: IJob
  public jobType: JobTypeList

  constructor() {
    this.list = {
      column: [],
      itemCount: 0,
      page: 1,
      pageCount: 1,
      result: [],
      defaultFilter: {},
    }
    this.byId = null
    this.create = {}
    this.update = {}
    this.delete = {}
    this.jobType = {
      data: [],
      itemCount: 0,
    }
  }
}

export interface JobList {
  column: Array<{
    text: string
    value: string
    type?: string
    options?: {
      orderable?: boolean
      lengthLimit?: number
      filter?: boolean
      operation: string[],
    },
  }>
  defaultFilter: object
  itemCount: number
  page: number
  pageCount: number
  result: IJob[]
  user?: {[userId: string]: IUser}
  patient?: {[patientId: string]: IPatient}
}

export interface IJob {
  _id: string,
  userId: string,
  type: string,
  startDate: string,
  endDate: string,
  patientId: string,
  aregiverPrice: string,
  contractPrice: string,
  createdAt: number,
  // endWorkingTime: string,
  foodPrice: string,
  caregiverPrice: string,
  insurancePrice: string,
  totalPrice?: number,
  time: Array<{
    startTime: string,
    endTime: string,
    people: number,
    price: number,
  }>
  priceDetail: Array<{
    price: string,
    name: string,
    unit: string,
    center: number,
    caregiver: number,
  }>
  status?: string,
  metadata?: any,
  patientTypeId: string,
  price: number,
  period: string,
  centerId?: string,
  contract?: string,
  // startWorkingTime: string,
  updatedAt: number,
}

export interface JobTypeList {
  data: IJobType[],
  itemCount: number
}
export interface IJobType {
  _id: string,
  period: string[],
  name: string,
  patientTypes: string[]
}

export default JobState
